import { setUserPlotSettingsAction } from "bkv-components/store_lib/actions/settingsActions";
import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import ColorPickerButton from "./UserPlotSettings/ColorPickerButton";

const Div = styled.div`
    max-width: 300px;

    .input-group-prepend {
        width: 110px;
    }

    .smoothing-label {
        width: 50px;
        padding: 0px;
        padding-left: 10px;
        /* justify-content: "center"; */
        text-align: center;
        display: flex;
        /* align-items: "center"; */
    }
`;

const FormSwitchSetting = (props) => {
    const { title, value, label, handleChange, disabled, className } = props;
    if (disabled) {
        return null;
    }

    return (
        <div className={className}>
            <div className="form-check form-switch">
                <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckDefault"
                >
                    {title}
                </label>
                <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                    value={value}
                    checked={value}
                    onChange={(e) => handleChange(e.target.checked)}
                />
            </div>
        </div>
    );
};

// Common Component
const InputGroup = ({
    label,
    id,
    step,
    value,
    onChange,
    onConfirm,
    validationMessage,
    isValid,
    style
  }) => (
    <div className="input-group mb-3 has-validation">
      <div className="input-group-prepend">
        <span className="input-group-text" id={`${id}-addon`}>
          {label}
        </span>
      </div>
      <input
        type="number"
        className="form-control"
        id={id}
        step={step}
        style={style}
        aria-describedby={`${id}-addon`}
        value={value}
        onChange={onChange}
      />
      <div className="input-group-append">
        <button
          className="btn btn-outline-secondary"
          type="button"
          id={`${id}-button`}
          onClick={onConfirm}
        >
          <i className="fa fa-check" aria-hidden="true"></i>
        </button>
      </div>
      <div className="invalid-feedback" htmlFor={id}>
        {validationMessage}
      </div>
    </div>
  );

function UserPlotSettings(props) {
    const [inner_plot_height, setInnerPlotHeight] = React.useState(0);
    const [inner_plot_separation, setInnerPlotSeparation] = React.useState(0);
    const [inner_smoothing, setInnerSmoothing] = React.useState(0);
    const [inner_font_size, setInnerFontSize] = React.useState(0);

    // const user_plot_settings = useSelector(
    //     (state) => state.settings.user_plot_settings
    // );

    const { user_plot_settings } = props;
    let { disabled_settings } = props;

    if (!disabled_settings || disabled_settings.constructor !== Array) {
        disabled_settings = [];
    }

    let enabled_plot_height = true;
    let enabled_plot_separation = true;
    let enabled_smoothing = true;
    let enabled_color_picker = true;
    //check if list
    if (
        disabled_settings &&
        typeof disabled_settings === "object" &&
        disabled_settings.constructor === Array
    ) {
        disabled_settings.map((setting) => {
            if (setting === "plot_height") {
                enabled_plot_height = false;
            }
            if (setting === "plot_separation") {
                enabled_plot_separation = false;
            }
            if (setting === "smoothing") {
                enabled_smoothing = false;
            }
            if (setting === "color_picker") {
                enabled_color_picker = false;
            }
            return null;
        });
    }
    // console.log(disabled_settings)

    let {
        merged_pressure_plots,
        log_INSFLG0,
        hide_comments,
        plot_height,
        plot_separation,
        y_axis_zoom_and_pan,
        connectgaps,
        smoothing,
        plot_font_size,
    } = user_plot_settings;

    if (!merged_pressure_plots) {
        merged_pressure_plots = false;
    }
    if (!log_INSFLG0) {
        log_INSFLG0 = false;
    }
    if (!hide_comments) {
        hide_comments = false;
    }
    if (!connectgaps) {
        connectgaps = false;
    }

    if  (!smoothing) {
        smoothing = 0;
    }

    const dispatch = useDispatch();
    const setUserPlotSettings = (e) => dispatch(setUserPlotSettingsAction(e));

    const setPlotHeight = (value) => {
        value = parseInt(value);

        if (value < 500) {
            value = 500;
        }
        if (value > 2000) {
            value = 2000;
        }

        setInnerPlotHeight(value);
        setUserPlotSettings({
            ...user_plot_settings,
            plot_height: value,
        });
    };

    const setPlotSeparation = (value) => {
        value = parseInt(value);
        if (value < 0) {
            value = 0;
        }
        if (value > 200) {
            value = 200;
        }

        setInnerPlotSeparation(value);
        setUserPlotSettings({
            ...user_plot_settings,
            plot_separation: value,
        });
    };

    const setPlotFontSize = (value) => {
        value = parseInt(value);
        if (value < 10) {
            value = 10;
        }
        if (value > 25) {
            value = 25;
        }

        setInnerFontSize(value);
        setUserPlotSettings({
            ...user_plot_settings,
            plot_font_size: value,
        });
    };


    const setSmoothing = (e) => {
        console.log('new smoothing value: ', inner_smoothing)
        let value = inner_smoothing;
        value = parseInt(value);
        if (value < 0) {
            value = 0;
        }
        setUserPlotSettings({
            ...user_plot_settings,
            smoothing: value,
        });
    };



    useEffect(() => {
        setInnerPlotHeight(plot_height);
        setInnerPlotSeparation(plot_separation);
        setInnerSmoothing(smoothing);
        setInnerFontSize(plot_font_size);
    }, [plot_height, plot_separation, plot_font_size]);

    return (
        <Div>
            <h4>Plot Settings</h4>
            <hr />

            {/* {enabled_merged_pressure_plots && (
                <div className="form-check form-switch">
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                    >
                        Merged Pressure Plots
                    </label>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        value={merged_pressure_plots}
                        checked={merged_pressure_plots}
                        onChange={(e) =>
                            setUserPlotSettings({
                                ...user_plot_settings,
                                merged_pressure_plots: e.target.checked,
                            })
                        }
                    />
                </div>
            )} */}
            <FormSwitchSetting
                title="Merged Plots"
                value={merged_pressure_plots}
                disabled={disabled_settings.includes("merged_pressure_plots")}
                handleChange={(value) =>
                    setUserPlotSettings({
                        ...user_plot_settings,
                        merged_pressure_plots: value,
                    })
                }
            />

            <FormSwitchSetting
                title="Logarithmic Gas Rate"
                value={log_INSFLG0}
                disabled={disabled_settings.includes("log_INSFLG0")}
                handleChange={(value) =>
                    setUserPlotSettings({
                        ...user_plot_settings,
                        log_INSFLG0: value,
                    })
                }
            />

            <FormSwitchSetting
                title="Y Axis Zoom & Pan"
                value={y_axis_zoom_and_pan}
                disabled={disabled_settings.includes("y_axis_zoom_and_pan")}
                handleChange={(value) =>
                    setUserPlotSettings({
                        ...user_plot_settings,
                        y_axis_zoom_and_pan: value,
                    })
                }
            />
            <FormSwitchSetting
                title="Connect Gaps"
                value={connectgaps}
                disabled={disabled_settings.includes("connectgaps")}
                handleChange={(value) =>
                    setUserPlotSettings({
                        ...user_plot_settings,
                        connectgaps: value,
                    })
                }
            />

            <FormSwitchSetting
                title="Hide Comments"
                value={hide_comments}
                disabled={disabled_settings.includes("hide_comments")}
                handleChange={(value) =>
                    setUserPlotSettings({
                        ...user_plot_settings,
                        hide_comments: value,
                    })
                }
            />
            <div className="mb-3" />

            {enabled_plot_height && (
                <InputGroup
                label="Plot height"
                id="plot_height"
                step={50}
                value={inner_plot_height}
                style={
                    inner_plot_height !== plot_height ? { color: "gray" } : {}
                }
                onChange={(e) => setInnerPlotHeight(parseInt(e.target.value))}
                onConfirm={() => setPlotHeight(inner_plot_height)}
                validationMessage="Range must be between 700 to 1400"
                />
            )}
            {enabled_plot_separation && (
                <InputGroup
                label="Separation"
                id="plot_separation"
                step={5}
                value={inner_plot_separation}
                style={
                    inner_plot_separation !== plot_separation ? { color: "gray" } : {}
                }
                onChange={(e) => setInnerPlotSeparation(parseInt(e.target.value))}
                onConfirm={() => setPlotSeparation(inner_plot_separation)}
                validationMessage="Range must be between 0 to 200"
                />
            )}
            {/* New Input Group for Font Size*/}
            <InputGroup
                label="Font Size"
                id="font_size"
                step={1}
                value={inner_font_size}
                style={
                    inner_font_size !== plot_font_size ? { color: "gray" } : {}
                }
                onChange={(e) => setInnerFontSize(parseInt(e.target.value))}
                onConfirm={() => setPlotFontSize(inner_font_size)}
                validationMessage="Range must be between 0 to 200"
                />


            {/* Smoothing */}
            {enabled_smoothing && (
            <div className="smoothing mb-3 d-flex justify-content-between">
                <div className="d-flex">
                <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon3">
                        Smoothing
                    </span>
                </div>
                <input
                        type="number"
                        className="form-control smoothing-label"
                        value={inner_smoothing}
                        disabled={true}
                    />
                    </div>
                <div className="d-flex align-items-center">
                <input
                    type="range"
                    className="form-range"
                    style={{padding: "10px 10px"}}
                    min="0"
                    max="50"
                    step="1"
                    value={inner_smoothing}
                    id="smoothing"
                    onChange={(e) => setInnerSmoothing(e.target.value)}
                    onMouseUp={(e) => setSmoothing(e)}
                ></input>
                </div>
            </div>
            )}

            {/* Color Picker */}
            {enabled_color_picker && (
                <div className="mb-3">
                    <ColorPickerButton />
                </div>
            )}

        </Div>
    );
}

export default UserPlotSettings;
